import type { SelfOwnedWidgetDefinition } from '../WidgetDefinition';
import { faTable } from '@fortawesome/pro-regular-svg-icons/faTable';
import type { TableV2WidgetModel, TableV2WidgetState } from 'src/models/TableV2WidgetModel';
import { TableV2WidgetModelImpl } from 'src/models/TableV2WidgetModel/impl';

export const tableV2WidgetDefinition: SelfOwnedWidgetDefinition<TableV2WidgetState, TableV2WidgetModel> = {
    type: 'table-v2' as const,
    nameKey: 'widgets::table-v2::name' as const,
    roles: ['widgets::table-v2'],
    icon: faTable,
    category: 'widgets::categories::misc' as const,
    isLocalOnly: true,
    widgetClass: TableV2WidgetModelImpl,
};
